// extracted by mini-css-extract-plugin
module.exports = {"menu-card-main-container":"menu_card_menu-card-main-container__KKbvZ","menu-card-text-container":"menu_card_menu-card-text-container__17Stq"};